import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import { fetchWithGet } from '../../httpHelper';
import { BrowserRouter as Router, Switch, Route, Link, useParams, useRouteMatch, useHistory } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import { Loader } from '../../components';
import ProjectDetail from './widgets/ProjectDetail';

export default function VendorProjectListPage() {
  let { path, url } = useRouteMatch();
  const rootName = 'Vendor Project List';
  return (
    <Router>
      <Switch>
        <Route exact path={path}>
          <UserList rootPath={url} rootName={rootName} />
        </Route>
        <Route exact path={`${path}/:userId`}>
          <ProjectList rootPath={url} rootName={rootName} />
        </Route>
        <Route path={`${path}/:userId/:id`}>
          <ProjectDetail rootPath={url} rootName={rootName} />
        </Route>
      </Switch>
    </Router>
  );
}

function UserList({ rootPath, rootName }) {
  const history = useHistory();
  const [uesrs, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState([]);
  const columns = ['#', 'Name', 'Role', 'Company Name', 'Phone No', 'On Going', 'No. of Project'];
  const options = {
    selectableRows: 'none',
    onRowClick: (rowData, rowMeta) => {
      history.push(`${rootPath}/${uesrs[rowMeta.dataIndex].id}`);
    },
    print: false,
    textLabels: {
      body: {
        noMatch: isLoading ? <Loader type={'spin'} /> : 'Sorry, no matching records found',
      },
    },
  };
  const fetchApi = async () => {
    setIsLoading(true);
    const result = await fetchWithGet('/users', {
      role: 'vendor',
      active: true,
      deleted: false,
      sortBy: 'email:asc',
    });

    if (result) {
      setUsers(result.data);
      setData(
        result.data.map((v, i) => [i + 1, v.name, _.startCase(v.role), v.companyName, v.tel, v.onGoing, v.noOfProject])
      );
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchApi();
  }, []);

  return (
    <div>
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={`${rootPath}`}>{rootName}</Link>
        </BreadcrumbItem>
      </Breadcrumb>
      <MUIDataTable data={data} columns={columns} options={options} />
    </div>
  );
}

function ProjectList({ rootPath, rootName }) {
  let { userId, id } = useParams();
  let { url } = useRouteMatch();
  const history = useHistory();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState([]);
  const columns = [
    '#',
    'Name',
    'Price',
    'Due Date',
    'Assign From',
    'Create Date',
    'Confirm or Reject Date',
    'Status',
    'Remark',
  ];
  const options = {
    selectableRows: 'none',
    onRowClick: (rowData, rowMeta) => {
      history.push(`${rootPath}/${userId}/${projects[rowMeta.dataIndex].id}`);
    },
    print: false,
    textLabels: {
      body: {
        noMatch: isLoading ? <Loader type={'spin'} /> : 'Sorry, no matching records found',
      },
    },
  };
  const fetchApi = async () => {
    setIsLoading(true);
    const result = await fetchWithGet('/projects/getTaskList');
    if (result) {
      const filteredList = result.data.filter((v) => v.assignTo.id === userId);
      setProjects(filteredList);
      setData(
        filteredList.map((v, i) => [
          i + 1,
          v.projectDetailId.name,
          v.assignPrice,
          v.dueDate && moment(v.dueDate).format('YYYY-MM-DD'),
          v.assignFrom.name,
          v.createdDatetime && moment(v.createdDatetime).format('YYYY-MM-DD'),
          v.confirmOrRejectDatetime && moment(v.confirmOrRejectDatetime).format('YYYY-MM-DD'),
          _.startCase(v.status),
          v.content,
        ])
      );
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchApi();
  }, []);

  return (
    <div>
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={`${rootPath}`}>{rootName}</Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to={`${rootPath}/${userId}`}>{projects.length > 0 ? projects[0].assignTo.name : userId}</Link>
        </BreadcrumbItem>
      </Breadcrumb>
      <MUIDataTable data={data} columns={columns} options={options} />
    </div>
  );
}
